import React from 'react';
import { IoCloseCircleOutline } from "react-icons/io5";

const PropertyImageModel = ({ selectedImage, isOpen, isClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={isClose}
    >
      <div
        className="bg-white p-4 relative rounded-lg max-w-full max-h-full"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={isClose}
          className="absolute bg-white rounded-full p-1 top-2 right-2 text-2xl text-red-500 hover:text-red-600 transition duration-200"
        >
          <IoCloseCircleOutline />
        </button>
        <img
          src={selectedImage}
          alt="Property"
          className="max-w-[90vw] max-h-[80vh] object-contain"
        />
      </div>
    </div>
  );
};

export default PropertyImageModel;
